module.exports = __webpack_public_path__ + "static/img/7696_phase_function_Paper_Points.f2d70fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7696_phase_function_Paper_Points.png
// module id = jR+p
// module chunks = 0